// https://github.com/jquense/yup/blob/3ad94724dc23175dd4378ac64c3d5396bebc52f2/src/util/printValue.js
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val !== +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val === null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

/*eslint-disable no-template-curly-in-string*/

var mixed = {
  "default": '${path} غير صالح.',
  required: '${path} هو حقل مطلوب',
  oneOf: '${path} يجب أن تكون واحدة من القيم التالية: ${values}',
  notOneOf: '${path} لا يجب أن تكون واحدة من القيم التالية: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " \u064A\u062C\u0628 \u0623\u0646 \u064A\u0643\u0648\u0646 `" + type + "` \u0646\u0648\u0639, " + ("\u0648\u0644\u0643\u0646 \u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0646\u0647\u0627\u0626\u064A\u0629 \u0643\u0627\u0646\u062A \u0641\u064A: `" + printValue(value, true) + "`") + (isCast ? " (\u0627\u0644\u0645\u062F\u0644\u0649 \u0628\u0647\u0627 \u0645\u0646 \u0642\u064A\u0645\u0629 `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n \u0625\u0630\u0627 \u0643\u0627\u0646 \u0627\u0644\u0645\u0642\u0635\u0648\u062F \"\u0644\u0627\u063A\u064A\u0629\" \u0643\u0642\u064A\u0645\u0629 \u0641\u0627\u0631\u063A\u0629 \u0645\u0645\u0627 \u0644\u0627 \u0634\u0643 \u0641\u064A\u0647 \u0644\u0644\u0627\u062D\u062A\u0641\u0627\u0644 \u0645\u062E\u0637\u0637 \u0643\u0645\u0627" + ' `.nullable()`';
    }

    return msg;
  }
};
var string = {
  length: '${path} يجب أن يكون بالضبط ${length} حرفا',
  min: '${path} يجب أن تكون على الأقل ${min} حرفا',
  max: '${path} يجب أن تكون على الأكثر ${max} حرفا',
  matches: '${path} يجب أن يطابق ما يلي: "${regex}"',
  email: '${path} يجب أن يكون عنوان بريد إلكتروني صالح',
  url: '${path} يجب أن يكون عنوان URL صالحا',
  trim: '${path} يجب أن تكون سلسلة قلص',
  lowercase: '${path} يجب أن تكون سلسلة صغيرة',
  uppercase: '${path} يجب أن تكون سلسلة الحالة العلوي'
};
var number = {
  min: '${path} يجب أن تكون أكبر من أو يساوي ${min}',
  max: '${path} يجب أن يكون أقل من أو يساوي ${max}',
  lessThan: '${path} يجب أن يكون أقل من ${less}',
  moreThan: '${path} يجب أن تكون أكبر من ${more}',
  positive: '${path} يجب أن يكون رقما موجبا',
  negative: '${path} يجب أن يكون رقما سالبا',
  integer: '${path} يجب أن يكون رقما'
};
var date = {
  min: '${path} يجب أن يكون حقل في وقت لاحق من ${min}',
  max: '${path} يجب أن يكون حقل في وقت سابق من ${max}'
};
var _boolean = {};
var object = {
  noUnknown: '${path} حقل لا يمكن أن يكون مفاتيح غير محددة في شكل وجوه'
};
var array = {
  min: 'يجب أن يكون ${path} حقل على الأقل ${min} من العناصر',
  max: '${path} يجب أن يكون الحقل أقل من أو يساوي إلى ${max} من العناصر'
};

var ar = {
  __proto__: null,
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  boolean: _boolean,
  object: object,
  array: array
};

/*eslint-disable no-template-curly-in-string*/

var mixed$1 = {
  "default": '${path} er ugyldig.',
  required: '${path} er et påkrævet felt',
  oneOf: '${path} skal være en af følgende værdier: ${values}',
  notOneOf: '${path} må ikke være en af følgende værdier: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " skal v\xE6re en `" + type + " type, " + ("Men den endelige v\xE6rdi var: `" + printValue(value, true) + "`") + (isCast ? " (cast fra v\xE6rdien `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Hvis \"null\" er beregnet til en tom v\xE6rdi, skal du s\xF8rge for at markere skemaet som" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$1 = {
  length: '${path} skal være nøjagtigt ${length} tegn',
  min: '${path} skal være mindst ${min} tegn',
  max: '${path} skal højst være ${max} tegn',
  matches: '${path} skal matche følgende: "${regex}"',
  email: '${path} skal være en gyldig e-mail addresse',
  url: '${path} skal være en gyldig URL',
  trim: '${path} skal være en trimmet streng',
  lowercase: '${path} skal være med små bogstaver',
  uppercase: '${path} skal være med store bogstaver'
};
var number$1 = {
  min: '${path} skal være større end eller lig med ${min}',
  max: '${path} skal være mindre end eller lig med ${max}',
  lessThan: '${path} skal være mindre end ${less}',
  moreThan: '${path} skal være større end ${more}',
  positive: '${path} skal være et positivt tal',
  negative: '${path} skal være et negativt tal',
  integer: '${path} skal være et heltal'
};
var date$1 = {
  min: '${path} felt skal være senere end ${min}',
  max: '${path} felt skal være tidligere end ${max}'
};
var _boolean$1 = {};
var object$1 = {
  noUnknown: '${path} feltet kan ikke have nøgler, der ikke er specificeret i objektets form'
};
var array$1 = {
  min: '${path} feltet skal have mindst ${min} genstande',
  max: '${path} feltet skal have mindre end eller lig med ${max} genstande'
};

var da = {
  __proto__: null,
  mixed: mixed$1,
  string: string$1,
  number: number$1,
  date: date$1,
  boolean: _boolean$1,
  object: object$1,
  array: array$1
};

/*eslint-disable no-template-curly-in-string*/

var mixed$2 = {
  "default": '${path} ist ungültig',
  required: '${path} ist ein Pflichtfeld',
  oneOf: '${path} muss einem der folgenden Werte entsprechen: ${values}',
  notOneOf: '${path} darf keinem der folgenden Werte entsprechen: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " muss vom Typ `" + type + "` sein, " + ("aber der Wert war: `" + printValue(value, true) + "`") + (isCast ? " (gecastet aus dem Wert `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Wenn \"null\" als leerer Wert gedacht ist, m\xFCssen Sie das Schema als `.nullable()` markieren.";
    }

    return msg;
  }
};
var string$2 = {
  length: '${path} muss genau ${length} Zeichen lang sein',
  min: '${path} muss mindestens ${min} Zeichen lang sein',
  max: '${path} darf höchstens ${max} Zeichen lang sein',
  matches: '${path} muss wie folgt aussehen: "${regex}"',
  email: '${path} muss eine gültige E-Mail-Adresse enthalten',
  url: '${path} muss eine gültige URL sein',
  trim: '${path} darf keine Leerzeichen am Anfang oder Ende enthalten',
  lowercase: '${path} darf nur Kleinschreibung enthalten',
  uppercase: '${path} darf nur Großschreibung enthalten'
};
var number$2 = {
  min: '${path} muss größer oder gleich ${min} sein',
  max: '${path} muss kleiner oder gleich ${max} sein',
  lessThan: '${path} muss kleiner sein als ${less}',
  moreThan: '${path} muss größer sein als ${more}',
  positive: '${path} muss eine positive Zahl sein',
  negative: '${path} muss eine negative Zahl sein',
  integer: '${path} muss eine ganze Zahl sein'
};
var date$2 = {
  min: '${path} muss später sein als ${min}',
  max: '${path} muss früher sein als ${max}'
};
var _boolean$2 = {};
var object$2 = {
  noUnknown: '${path}-Feld darf keine Schlüssel verwenden, die nicht im "Objekt-Shape" definiert wurden'
};
var array$2 = {
  min: '${path}-Feld muss mindestens ${min} Einträge haben',
  max: '${path}-Feld darf höchstens ${max} Einträge haben'
};

var de = {
  __proto__: null,
  mixed: mixed$2,
  string: string$2,
  number: number$2,
  date: date$2,
  boolean: _boolean$2,
  object: object$2,
  array: array$2
};

/*eslint-disable no-template-curly-in-string*/

var mixed$3 = {
  "default": '${path} no es válido.',
  required: '${path} es un campo obligatorio',
  oneOf: '${path} debe ser uno de los siguientes valores: ${values}',
  notOneOf: '${path} no debe ser uno de los siguientes valores: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " debe ser un `" + type + "` Tipo, " + ("pero el valor final fue: `" + printValue(value, true) + "`") + (isCast ? " (Obtenido del valor `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Si \"nulo\" es intencionalmente un valor vac\xEDo, aseg\xFArese de marcar el esquema como" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$3 = {
  length: '${path} debe tener exactamente ${length} caracteres',
  min: '${path} debe tener como mínimo ${min} caracteres',
  max: '${path} debe tener como máximo ${max} caracteres',
  matches: '${path} debe coincidir con lo siguiente: "${regex}"',
  email: '${path} debe ser un correo electrónico válido',
  url: '${path} debe ser una URL válida',
  trim: '${path} debe ser una cadena recortada',
  lowercase: '${path} debe ser una cadena en minúsculas',
  uppercase: '${path} debe ser una cadena en mayúsculas'
};
var number$3 = {
  min: '${path} debe ser mayor o igual a ${min}',
  max: '${path} debe ser menor o igual a ${max}',
  lessThan: '${path} debe ser menor a ${less}',
  moreThan: '${path} debe ser mayor a ${more}',
  positive: '${path} debe ser un número positivo',
  negative: '${path} debe ser un número negativo',
  integer: '${path} debe ser un entero'
};
var date$3 = {
  min: 'El campo ${path} debe ser posterior a ${min}',
  max: 'El campo ${path} debe ser anterior a ${max}'
};
var _boolean$3 = {};
var object$3 = {
  noUnknown: 'El campo ${path} tiene claves no especificadas en el objeto'
};
var array$3 = {
  min: 'El campo ${path} debe tener como mínimo ${min} elementos',
  max: 'El campo ${path} debe tener como máximo ${max} elementos'
};

var es = {
  __proto__: null,
  mixed: mixed$3,
  string: string$3,
  number: number$3,
  date: date$3,
  boolean: _boolean$3,
  object: object$3,
  array: array$3
};

/*eslint-disable no-template-curly-in-string*/

var mixed$4 = {
  "default": '${path} est invalide.',
  required: '${path} est un champ obligatoire',
  oneOf: "${path} doit être l'une des valeurs suivantes : ${values}",
  notOneOf: "${path} ne doit pas être l'une des valeurs suivantes : ${values}",
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " doit \xEAtre un type `" + type + "`, " + ("mais la valeur finale \xE9tait: `" + printValue(value, true) + "`") + (isCast ? " (coul\xE9e de la valeur `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Si \xAB null \xBB est con\xE7ue comme une valeur vide assurez-vous de marquer le sch\xE9ma comme" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$4 = {
  length: '${path} doit être exactement ${length} caractères',
  min: '${path} doit être au moins ${min} caractères',
  max: '${path} doit être au plus ${max} caractères',
  matches: '${path} doit correspondre à ce qui suit : "${regex}"',
  email: '${path} doit être un email valide',
  url: '${path} doit être une URL valide',
  trim: '${path} doit être une chaîne garnie',
  lowercase: '${path} doit être une chaîne en minuscule',
  uppercase: '${path} doit être une chaîne de majuscules'
};
var number$4 = {
  min: '${path} doit être supérieure ou égale à ${min}',
  max: '${path} doit être inférieur ou égal à ${max}',
  lessThan: '${path} doit être inférieure à ${less}',
  moreThan: '${path} doit être supérieure à ${more}',
  positive: '${path} doit être un nombre positif',
  negative: '${path} doit être un nombre négatif',
  integer: '${path} doit être un entier'
};
var date$4 = {
  min: '${path} champ doit être au plus tôt ${min}',
  max: 'champ ${path} doit être au plus tard ${max}'
};
var _boolean$4 = {};
var object$4 = {
  noUnknown: "champ ${path} ne peut pas avoir des clés non spécifiées dans la forme de l'objet"
};
var array$4 = {
  min: 'champ ${path} doit avoir au moins ${min} articles',
  max: '${path} champ doit avoir inférieur ou égal à ${max} articles'
};

var fr = {
  __proto__: null,
  mixed: mixed$4,
  string: string$4,
  number: number$4,
  date: date$4,
  boolean: _boolean$4,
  object: object$4,
  array: array$4
};

/*eslint-disable no-template-curly-in-string*/

var mixed$5 = {
  "default": '${path} לא קיים או לא תקין',
  required: '${path} הינו שדה חובה',
  oneOf: 'על ${path} להיות מהערכים הבאים: ${values}',
  notOneOf: 'אסור ${path} להיות מהערכים הבאים: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05E1\u05D5\u05D2 `" + type + "`, " + ("\u05D0\u05D1\u05DC \u05D4\u05EA\u05E7\u05D1\u05DC: `" + printValue(value, true) + "`") + (isCast ? " (cast from the value `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
var string$5 = {
  length: '${path} חייב להכיל ${length} תווים בדיוק',
  min: '${path} חייב להכיל לפחות ${min} תווים',
  max: '${path} חייב להכיל פחות מ${max} תווים',
  matches: '${path} חייב להיות זהה ל: "${regex}"',
  email: '${path} צריך להיות מייל חוקי',
  url: '${path} צריך להיות כתובת חוקית',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
var number$5 = {
  min: '${path} חייב להיות גדול או שווה ל ${min}',
  max: '${path}חייב להיות קטן או שווה ל ${max}',
  lessThan: '${path} חייב להיות קטן מ ${less}',
  moreThan: '${path} חייב להיות גדול מ ${more}',
  positive: '${path} מוכרח להיות חיובי',
  negative: '${path} מוכרח להיות שלילי',
  integer: '${path} חייב להיות מספר שלם'
};
var date$5 = {
  min: '${path} צריך להיות אחרי ${min}',
  max: '${path} צריך להיות לפני ${max}'
};
var _boolean$5 = {};
var object$5 = {
  noUnknown: '${path} חייב להכיל את התבנית הספציפית של אובייקט התבנית'
};
var array$5 = {
  min: '${path} צריך להכיל לפחות ${min} פריטים',
  max: '${path} צריך להכיל פחות מ ${max} פריטים'
};

var he = {
  __proto__: null,
  mixed: mixed$5,
  string: string$5,
  number: number$5,
  date: date$5,
  boolean: _boolean$5,
  object: object$5,
  array: array$5
};

/*eslint-disable no-template-curly-in-string*/

var mixed$6 = {
  "default": '${path} tidak valid.',
  required: '${path} wajib diisi',
  oneOf: '${path} tidak valid',
  notOneOf: '${path} tidak valid',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " harus merupakan tipe `" + type + "`, " + ("tetapi nilai akhir adalah: `" + printValue(value, true) + "`") + (isCast ? " (dilemparkan dari nilai `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Jika \"null\" dimaksudkan sebagai nilai kosong, pastikan untuk menandai skema sebagai" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$6 = {
  length: '${path} harus persis ${length} karakter',
  min: '${path} harus setidaknya ${min} karakter',
  max: '${path} harus paling banyak ${max} karakter',
  matches: '${path} harus cocok dengan yang berikut: "${regex}"',
  email: '${path} harus merupakan email yang valid',
  url: '${path} harus merupakan url yang valid',
  trim: '${path} harus merupakan string yang dipangkas',
  lowercase: '${path} harus merupakan lowercase',
  uppercase: '${path} harus merupakan uppercase'
};
var number$6 = {
  min: '${path} harus lebih besar dari atau sama dengan ${min}',
  max: '${path} harus kurang dari atau sama dengan ${max}',
  lessThan: '${path} harus kurang dari ${less}',
  moreThan: '${path} harus lebih besar dari ${more}',
  positive: '${path} harus merupakan bilangan positif',
  negative: '${path} harus merupakan bilangan negatif',
  integer: '${path} harus merupakan bilangan bulat'
};
var date$6 = {
  min: '${path} harus lebih lambat dari ${min}',
  max: '${path} harus lebih awal dari ${max}'
};
var _boolean$6 = {};
var object$6 = {
  noUnknown: '${path} tidak dapat memiliki kunci yang tidak ditentukan dalam bentuk objek'
};
var array$6 = {
  min: '${path} harus memiliki setidaknya ${min} item',
  max: '${path} harus memiliki kurang dari atau sama dengan item ${max}'
};

var id = {
  __proto__: null,
  mixed: mixed$6,
  string: string$6,
  number: number$6,
  date: date$6,
  boolean: _boolean$6,
  object: object$6,
  array: array$6
};

/*eslint-disable no-template-curly-in-string*/

var mixed$7 = {
  "default": '${path} non è valido.',
  required: '${path} è un campo obbligatorio',
  oneOf: '${path} deve contenere uno dei seguenti valori: ${values}',
  notOneOf: '${path} deve essere diverso dai seguenti valori: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " deve essere un `" + type + "` tipo, " + ("ma il valore finale \xE8: `" + printValue(value, true) + "`") + (isCast ? " (valore originale: `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Se \"null\" \xE8 inteso come un valore vuoto assicurarsi di settare lo schema come" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$7 = {
  length: '${path} deve avere esattamente ${length} caratteri',
  min: '${path} deve avere almeno ${min} caratteri',
  max: '${path} deve avere al massimo ${max} caratteri',
  matches: '${path} deve corrispondere al seguente: "${regex}"',
  email: '${path} deve essere un indirizzo email valido',
  url: '${path} deve essere un URL valido',
  trim: '${path} deve essere una stringa senza spazi iniziali/finali',
  lowercase: '${path} deve essere una stringa in minuscolo',
  uppercase: '${path} deve essere una stringa in maiuscolo'
};
var number$7 = {
  min: '${path} deve essere maggiore o uguale a ${min}',
  max: '${path} deve essere inferiore o uguale a ${max}',
  lessThan: '${path} deve essere inferiore a ${less}',
  moreThan: '${path} deve essere maggiore di ${more}',
  positive: '${path} deve essere un numero positivo',
  negative: '${path} deve essere un numero negativo',
  integer: '${path} deve essere un numero intero'
};
var date$7 = {
  min: '${path} deve essere successiva al ${min}',
  max: '${path} deve essere precedente al ${max}'
};
var _boolean$7 = {};
var object$7 = {
  noUnknown: "${path} contiene delle chiavi non specificate nella forma dell'oggetto"
};
var array$7 = {
  min: '${path} deve avere almeno ${min} elementi',
  max: '${path} non deve avere più di ${max} elementi'
};

var it = {
  __proto__: null,
  mixed: mixed$7,
  string: string$7,
  number: number$7,
  date: date$7,
  boolean: _boolean$7,
  object: object$7,
  array: array$7
};

/*eslint-disable no-template-curly-in-string*/

var mixed$8 = {
  "default": '${path} er ugyldig.',
  required: '${path} er et nødvendig felt',
  oneOf: '${path} må være en av de følgende verdier: ${values}',
  notOneOf: '${path} må ikke være en av de følgende verdier: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " m\xE5 v\xE6re en `" + type + "` typen, " + ("men den endelige verdien var: `" + printValue(value, true) + "`") + (isCast ? " (st\xF8pt fra verdien `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Hvis \"null\" er ment som en tom verdi s\xF8rg for \xE5 markere skjemaet som" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$8 = {
  length: '${path} må være nøyaktig ${length} tegn',
  min: '${path} må være minst ${min} tegn',
  max: '${path} må være mest ${max} tegn',
  matches: '${path} må samsvare med følgende: "${regex}"',
  email: '${path} må være en gyldig e-post',
  url: '${path} må være en gyldig nettadresse',
  trim: '${path} må være en trimmet streng',
  lowercase: '${path} må være i små bokstaver',
  uppercase: '${path} må være i store bokstaver'
};
var number$8 = {
  min: '${path} må være større enn eller lik ${min}',
  max: '${path} må være mindre enn eller lik ${max}',
  lessThan: '${path} må være mindre enn ${less}',
  moreThan: '${path} må være større enn ${more}',
  positive: '${path} må være et positivt tall',
  negative: '${path} må være et negativt tall',
  integer: '${path} må være et heltall'
};
var date$8 = {
  min: '${path} feltet må være senere enn ${min}',
  max: '${path} feltet må være tidligere enn ${max}'
};
var _boolean$8 = {};
var object$8 = {
  noUnknown: '${path} felt kan ikke har nøkler som ikke er spesifisert i objektet form'
};
var array$8 = {
  min: '${path} feltet må ha minst ${min} elementer',
  max: '${path} feltet må ha mindre enn eller lik ${max} elementer'
};

var nb = {
  __proto__: null,
  mixed: mixed$8,
  string: string$8,
  number: number$8,
  date: date$8,
  boolean: _boolean$8,
  object: object$8,
  array: array$8
};

/*eslint-disable no-template-curly-in-string*/

var mixed$9 = {
  "default": '${path} is ongeldig.',
  required: '${path} is een verplicht veld',
  oneOf: '${path} moet één van de volgende waarden zijn: ${values}',
  notOneOf: '${path} mag niet een van de volgende waarden zijn: ${values}: ',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " moet een `" + type + "` zijn, " + ("maar de uiteindelijke waarde was: `" + printValue(value, true) + "`") + (isCast ? " (gegoten uit de waarde `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Als \"null\" is bedoeld als een lege waarde moet u het schema markeren als" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$9 = {
  length: '${path} moet precies ${length} karakters lang zijn',
  min: '${path} moet minimaal ${min} karakters bevatten',
  max: '${path} mag maximaal ${max} karakters bevatten',
  matches: '${path} moet overeenkomen met het volgende: "${regex}"',
  email: '${path} moet een geldig e-mailadres zijn',
  url: '${path} moet een geldige URL zijn',
  trim: '${path} mag geen begin- of eindspaties bevatten',
  lowercase: '${path} mag alleen bestaan uit kleine letters',
  uppercase: '${path} mag alleen bestaan uit hoofdletters'
};
var number$9 = {
  min: '${path} moet groter dan of gelijk zijn aan ${min}',
  max: '${path} moet lager dan of gelijk zijn aan ${max}',
  lessThan: '${path} moet lager zijn dan ${less}',
  moreThan: '${path} moet hoger zijn dan ${more}',
  positive: '${path} moet een positief getal zijn',
  negative: '${path} moet negatief getal zijn',
  integer: '${path} moet een getal zijn'
};
var date$9 = {
  min: '${path} moet later dan ${min} zijn',
  max: '${path} moet eerder dan ${max} zijn'
};
var _boolean$9 = {};
var object$9 = {
  noUnknown: '${path} mag geen waarden bevatten die niet zijn opgegeven in het object'
};
var array$9 = {
  min: '${path} moet ten minste ${min} items bevatten',
  max: '${path} moet minder of gelijk zijn aan ${max} items'
};

var nl = {
  __proto__: null,
  mixed: mixed$9,
  string: string$9,
  number: number$9,
  date: date$9,
  boolean: _boolean$9,
  object: object$9,
  array: array$9
};

/*eslint-disable no-template-curly-in-string*/

var mixed$a = {
  "default": '${path} é inválido.',
  required: '${path} é um campo obrigatório',
  oneOf: '${path} deve ser um dos seguintes valores: ${values}',
  notOneOf: '${path} não deve ser um dos seguintes valores: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " deve ser um tipo de `" + type + "`, " + ("Mas o valor final foi: `" + printValue(value, true) + "`") + (isCast ? " (Elenco do valor `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Se \"null\" pretender como um valor vazio, certifique-se de marcar o esquema como" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$a = {
  length: '${path} deve ser exatamente ${length} caracteres',
  min: '${path} deve ser pelo menos ${min} caracteres',
  max: '${path} deve ser no máximo ${max} caracteres',
  matches: '${path} deve corresponder ao seguinte: "${regex}"',
  email: '${path} deve ser um email válido',
  url: '${path} deve ser um URL válido',
  trim: '${path} deve ser uma corda aparada',
  lowercase: '${path} deve ser uma cadeia minúscula',
  uppercase: '${path} deve ser uma cadeia maiúscula'
};
var number$a = {
  min: '${path} deve ser maior ou igual a ${min}',
  max: '${path} deve ser menor ou igual a ${max}',
  lessThan: '${path} deve ser menor que ${less}',
  moreThan: '${path} deve ser maior que ${more}',
  positive: '${path} deve ser um número positivo',
  negative: '${path} deve ser um número negativo',
  integer: '${path} deve ser um inteiro'
};
var date$a = {
  min: 'Campo ${path} deve ser mais tarde do que ${min}',
  max: '${path} deve ser mais cedo do que ${max}'
};
var _boolean$a = {};
var object$a = {
  noUnknown: 'Campo ${path} não pode ter chaves não especificadas na forma do objeto'
};
var array$a = {
  min: 'O campo ${path} deve ter pelo menos ${min} itens',
  max: 'O campo ${path} deve ter menos ou igual a itens ${max}'
};

var pt = {
  __proto__: null,
  mixed: mixed$a,
  string: string$a,
  number: number$a,
  date: date$a,
  boolean: _boolean$a,
  object: object$a,
  array: array$a
};

/*eslint-disable no-template-curly-in-string*/

var mixed$b = {
  "default": '${path} geçerli değildir',
  required: '${path} zorunlu bir alandır',
  oneOf: '${path} bu değerlerden biri olmak zorundadır: ${values}',
  notOneOf: '${path} bu değerlerden biri olmamalıdır.: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + ", `" + type + "`, t\xFCr\xFCnde olmak zorundad\u0131r" + ("fakat son de\u011Fer budur: `" + printValue(value, true) + "`") + (isCast ? "\xE7evirilen orjinal de\u011Fer: ( `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n  \"null\" olarak tan\u0131mlanm\u0131\u015F ise \u015Femay\u0131 \u015Fu \u015Fekilde i\u015Faretledi\u011Finizden emin olun: " + ' `.nullable()`';
    }

    return msg;
  }
};
var string$b = {
  length: '${path}, ${length} karakter olmalıdır',
  min: '${path} en az ${min} karakter olmalıdır',
  max: '${path} en fazla ${max} karakter olmalıdır',
  matches: '${path}, "${regex}" ile eşleşmelidir',
  email: '${path} geçerli bir email olmalıdır',
  url: '${path} geçerli bir url olmalıdır',
  trim: '${path} kırpılmış olmalıdır',
  lowercase: '${path} küçük harflerden oluşmalıdır',
  uppercase: '${path} büyük harflerden oluşmalıdır'
};
var number$b = {
  min: '${path}, en az ${min} veya daha fazla hane olmalıdır',
  max: '${path} en fazla ${max} veya daha az hane olmalıdır',
  lessThan: '${path}, ${less} haneden az olmalıdır',
  moreThan: '${path}, ${more} haneden fazla olmalıdır',
  positive: '${path} pozitif bir sayı olmalıdır',
  negative: '${path} negatif bir sayı olmalıdır',
  integer: '${path} bir tamsayı olmalıdır'
};
var date$b = {
  min: '${path}, ${min} tarihinden ileri bir tarih olmalıdır',
  max: '${path}, ${max} tarihinden önce bir tarih olmalıdır'
};
var _boolean$b = {};
var object$b = {
  noUnknown: '${path} alanında nesne olmayan değerler bulunamaz'
};
var array$b = {
  min: '${path}, en az ${min} eleman içermelidir',
  max: '${path}, en fazla ${max} eleman içermelidir'
};

var tr = {
  __proto__: null,
  mixed: mixed$b,
  string: string$b,
  number: number$b,
  date: date$b,
  boolean: _boolean$b,
  object: object$b,
  array: array$b
};

/*eslint-disable no-template-curly-in-string*/

var mixed$c = {
  "default": '${path} neteisinga.',
  required: '${path} yra būtinas laukas',
  oneOf: '${path} turi būti iš šių verčių: ${values}',
  notOneOf: '${path} neturi būti iš šių verčių: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " turi b\u016Bti `" + type + "` tipas, " + ("Bet galutin\u0117 vert\u0117 buvo: `" + printValue(value, true) + "` `") + (isCast ? " (I\u0161meskite i\u0161 vert\u0117s `" + printValue(originalValue, true) + "` `)." : '.');

    if (value === null) {
      msg += "\n Jei \u201Enulis\u201C yra skirtas kaip tu\u0161\u010Dia vert\u0117, b\u016Btinai pa\u017Eym\u0117kite schem\u0105 kaip" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$c = {
  length: '${path} turi būti iš ${length} simbolių',
  min: '${path} turi būti bent ${min} simboliai',
  max: '${path} turi būti daugiausia iš ${max} simbolių',
  matches: '${path} turi atitikti šiuos dalykus: „${regex}“',
  email: '${path} turi būti galiojantis el. adresas',
  url: '${path} turi būti galiojantis URL',
  trim: '${path} turi būti be tarpų pradžioje ir gale',
  lowercase: '${path} turi būti tik mažosios raidės',
  uppercase: '${path} turi būti tik didžiosios raidės'
};
var number$c = {
  min: '${path} turi būti daugiau arba lygu ${min}',
  max: '${path} turi būti mažiau arba lygu ${max}',
  lessThan: '${path} turi būti mažiau nei ${less}',
  moreThan: '${path} turi būti daugiau nei ${more}',
  positive: '${path} turi būti teigiamas skaičius',
  negative: '${path} turi būti neigiamas skaičius',
  integer: '${path} turi būti sveikasis skaičius'
};
var date$c = {
  min: '${path} turi būti vėliau nei ${min}',
  max: '${path} turi būti anksčiau nei ${max}'
};
var _boolean$c = {};
var object$c = {
  noUnknown: '${path} negali būti raktų, nenurodytų objekto formoje'
};
var array$c = {
  min: '${path} turi būti bent ${min} elementai',
  max: '${path} turi būti ne daugiau nei ${max} elementai'
};

var lt = {
  __proto__: null,
  mixed: mixed$c,
  string: string$c,
  number: number$c,
  date: date$c,
  boolean: _boolean$c,
  object: object$c,
  array: array$c
};

/*eslint-disable no-template-curly-in-string*/

var mixed$d = {
  "default": 'Pole ${path} jest niepoprawne',
  required: 'Pole ${path} jest wymagane',
  oneOf: 'Pole ${path} musi mieć jedną z następujących wartości: ${values}',
  notOneOf: 'Pole ${path} nie może mieć jednej z następujących wartości: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = "Pole " + path + " musi by\u0107 typu \u201E" + type + "`, " + ("ale ostateczna warto\u015B\u0107 to: `" + printValue(value, true) + "` `") + (isCast ? " (rzutowana z warto\u015Bci `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Je\u015Bli \u201Enull\u201D jest przeznaczony jako pusta warto\u015B\u0107, pami\u0119taj, aby oznaczy\u0107 schemat jako" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$d = {
  length: 'Pole ${path} musi być dokładnie ${length} znaków',
  min: 'Pole ${path} musi być co najmniej ${min} znaków',
  max: 'Pole ${path} może mieć co najwyżej ${max} znaków',
  matches: 'Pole ${path} musi pasować do następującego wzorca: „${regex}”',
  email: 'Pole ${path} musi być poprawnym adresem email',
  url: 'Pole ${path} musi być poprawnym adresem URL',
  trim: 'Pole ${path} musi być tekstem bez spacji na początku i na końcu',
  lowercase: 'Pole ${path} może mieć tylko małe litery',
  uppercase: 'Pole ${path} może mieć tylko wielkie litery'
};
var number$d = {
  min: 'Pole ${path} musi być liczbą większą lub równą ${min}',
  max: 'Pole ${path} musi być liczą mniejszą lub równą ${max}',
  lessThan: 'Pole ${path} musi być liczbą mniejszą od ${less}',
  moreThan: 'Pole ${path} musi być liczbą większą od ${more}',
  positive: 'Pole ${path} musi być liczbą dodatnią',
  negative: 'Pole ${path} musi być liczbą ujemną',
  integer: 'Pole ${path} musi być liczbą całkowitą'
};
var date$d = {
  min: 'Pole ${path} musi zawierać datę późniejszą niż ${min}',
  max: 'Pole ${path} musi zawierać datę wcześniejszą niż ${max}'
};
var _boolean$d = {};
var object$d = {
  noUnknown: 'Pole ${path} nie może zawierać nieznanych kluczy'
};
var array$d = {
  min: 'Pole ${path} musi zawierać co najmniej ${min} elementów',
  max: 'Pole ${path} może zawierać co najwyżej ${max} elementów'
};

var pl = {
  __proto__: null,
  mixed: mixed$d,
  string: string$d,
  number: number$d,
  date: date$d,
  boolean: _boolean$d,
  object: object$d,
  array: array$d
};

/*eslint-disable no-template-curly-in-string*/
var typeTranslations = {
  string: 'text',
  number: 'číslo',
  "boolean": 'boolean',
  date: 'dátum',
  object: 'objekt',
  array: 'pole'
};

var getTypeTranslation = function getTypeTranslation(type) {
  return typeTranslations[type] ? typeTranslations[type] : type;
}; // Based on https://github.com/jquense/yup/blob/2973d0a/src/locale.js


var mixed$e = {
  "default": '${path} je nesprávne',
  required: '${path} je povinné pole',
  oneOf: '${path} musí byť jednou z nasledujúcich hodnôt: ${values}',
  notOneOf: '${path} nesmie byť jednou z nasledujúcich hodnôt: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " mus\xED by\u0165 `" + getTypeTranslation(type) + "`, " + ("ale kone\u010Dn\xE1 hodnota bola: `" + printValue(value, true) + "`") + (isCast ? " (obsadenie z hodnoty `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Ak je \u201Enull\u201C ur\u010Den\xFD ako pr\xE1zdna hodnota, nezabudnite ozna\u010Di\u0165 sch\xE9mu ako" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$e = {
  length: '${path} musí mať presne ${length} znakov',
  min: '${path} musí mať aspoň ${min} znakov',
  max: '${path} musí mať najviac ${max} znakov',
  matches: '${path} sa musí zhodovať s nasledujúcimi: „${regex}“',
  email: '${path} musí byť platný e -mail',
  url: '${path} musí byť platná URL adresa ',
  trim: '${path} nesmie začínať alebo končiť medzerou',
  lowercase: '${path} musí obsahovať iba malé písmená',
  uppercase: '${path} musí obsahovať iba veľké písmená'
};
var number$e = {
  min: '${path} musí byť väčší alebo rovný ${min}',
  max: '${path} musí byť menší alebo rovný ${max}',
  lessThan: '${path} musí byť menší ako ${less}',
  moreThan: '${path} musí byť väčší ako ${more}',
  positive: '${path} musí byť kladné číslo',
  negative: '${path} musí byť záporné číslo',
  integer: '${path} musí byť celé číslo'
};
var date$e = {
  min: '${path} musí byť po ${min}',
  max: '${path} musí byť pred ${max}'
};
var _boolean$e = {};
var object$e = {
  noUnknown: '${path} pole nemôže mať kľúče zadané v tvare objektu'
};
var array$e = {
  min: '${path} musí obsahovať aspoň ${min} položiek',
  max: '${path} musí obsahovať najviac ${max} položiek'
};

var sk = {
  __proto__: null,
  mixed: mixed$e,
  string: string$e,
  number: number$e,
  date: date$e,
  boolean: _boolean$e,
  object: object$e,
  array: array$e
};

/*eslint-disable no-template-curly-in-string*/

var mixed$f = {
  "default": '${path} содержит ошибку',
  required: 'Поле ${path} обязательное для заполнения',
  oneOf: 'Поле ${path} должно содержать одно из следующих значение: ${values}',
  notOneOf: 'Поле ${path} не должно содержать одно из следующих значение: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = "\u041F\u043E\u043B\u0435 " + path + " \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C  `" + type + "` \u0442\u0438\u043F\u043E\u043C, " + ("\u043D\u043E \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435: `" + printValue(value, true) + "` `") + (isCast ? " (\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043E \u0438\u0437 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n \u0415\u0441\u043B\u0438 \"null\" \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0443\u0441\u0442\u044B\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C, \u0443\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C \u0447\u0442\u043E \u0441\u0445\u0435\u043C\u0430 \u043F\u043E\u043C\u0435\u0447\u0435\u043D\u0430 \u043A\u0430\u043A `.nullable()`";
    }

    return msg;
  }
};
var string$f = {
  length: 'Поле ${path} должно иметь длину ${length} символов',
  min: 'Поле ${path} должно содержать минимум ${min} символов',
  max: 'Поле ${path} должно содержать не более ${max} символов',
  matches: 'Поле ${path} должно совпадать со следующим регулярном выражением: „${regex}”',
  email: 'Поле ${path} должно быть электронной почтой',
  url: 'Поле ${path} должно быть валидной ссылкой',
  trim: 'Поле ${path} не должно содержать в начале или в конце пробелы',
  lowercase: 'Поле ${path} должно быть в нижним регистре',
  uppercase: 'Поле ${path} должно быть в верхнем регистре'
};
var number$f = {
  min: 'Поле ${path} должно быть больше или равно ${min}',
  max: 'Поле ${path} должно быть меньше или равно ${max}',
  lessThan: 'Поле ${path} должно быть меньше чем ${less}',
  moreThan: 'Поле ${path} должно быть больше ${more}',
  positive: 'Поле ${path} должно быть положительном числом',
  negative: 'Поле ${path} должно быть негативном числом',
  integer: 'Поле ${path} должно быть целым числом'
};
var date$f = {
  min: 'Поле ${path} не может быть меньше начальной ${min}',
  max: 'Поле ${path} не может быть больше конечной ${max}'
};
var _boolean$f = {
  isValue: 'Поле ${path} должно иметь значение: ${value}'
};
var object$f = {
  noUnknown: 'Поле ${path} не может содержать неизвестные ключи'
};
var array$f = {
  min: 'Поле ${path} должно быть указано не менее ${min} элементов',
  max: 'Поле ${path} должно быть указано не более ${max} элементов'
};

var ru = {
  __proto__: null,
  mixed: mixed$f,
  string: string$f,
  number: number$f,
  date: date$f,
  boolean: _boolean$f,
  object: object$f,
  array: array$f
};

/*eslint-disable no-template-curly-in-string*/

var typeTranslations$1 = {
  string: 'text',
  number: 'číslo',
  "boolean": 'boolean',
  date: 'datum',
  object: 'objekt',
  array: 'pole'
};

var getTypeTranslation$1 = function getTypeTranslation(type) {
  return typeTranslations$1[type] ? typeTranslations$1[type] : type;
};

var mixed$g = {
  "default": '${path} je nesprávné',
  required: '${path} je povinné pole',
  oneOf: '${path} musí být jednou z nasledujících hodnot: ${values}',
  notOneOf: '${path} nesmí být jednou z nasledujících hodnot: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " mus\xED b\xFDt `" + getTypeTranslation$1(type) + "`, " + ("ale kone\u010Dn\xE1 hodnota byla: `" + printValue(value, true) + "`") + (isCast ? " (obsadenie z hodnoty `" + printValue(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n Pokud je \u201Enull\u201C ur\u010Den\xFD jako pr\xE1zdn\xE1 hodnota, nezapom\u011B\u0148te ozna\u010Dit sch\xE9ma jako" + ' `.nullable()`';
    }

    return msg;
  }
};
var string$g = {
  length: '${path} musí mít ${length} znaků',
  min: '${path} musí mít alespoň ${min} znaků',
  max: '${path} musí mít nanejvýš ${max} znaků',
  matches: '${path} se musí shodovat s následujícími: „${regex}“',
  email: '${path} musí být platný e-mail',
  url: '${path} musí být platná URL adresa ',
  trim: '${path} nemůže začínat nebo končit mezerou',
  lowercase: '${path} musí obsahovat pouze malá písmena',
  uppercase: '${path} musí obsahovat pouze velká písmena'
};
var number$g = {
  min: '${path} musí být větší nebo rovno ${min}',
  max: '${path} musí být menší nebo rovno ${max}',
  lessThan: '${path} musí být měnší než ${less}',
  moreThan: '${path} musí být větší než ${more}',
  positive: '${path} musí být kladné číslo',
  negative: '${path} musí být záporné číslo',
  integer: '${path} musí být celé číslo'
};
var date$g = {
  min: '${path} musí být po ${min}',
  max: '${path} musí být před ${max}'
};
var _boolean$g = {};
var object$g = {
  noUnknown: '${path} pole nemůže mít klíče zadané ve tvaru objektu'
};
var array$g = {
  min: '${path} musí obsahovat alespoň ${min} položek',
  max: '${path} musí obsahovat maximálně ${max} položek'
};

var cs = {
  __proto__: null,
  mixed: mixed$g,
  string: string$g,
  number: number$g,
  date: date$g,
  boolean: _boolean$g,
  object: object$g,
  array: array$g
};

/*eslint-disable no-template-curly-in-string*/

var mixed$h = {
  "default": '${path}da xatolik mavjud',
  required: '${path} maydoniga ma\'lumot kiritilmagan',
  oneOf: '${path} maydoni ${values} qiymatlardan bittasi emas',
  notOneOf: '${path} maydoni ${values} qiymatlarini qabul qilmaydi',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " maydon `" + type + "` turiga tegishli emas. " + (isCast ? "`" + printValue(originalValue, true) + "` dan olingan o" : 'O') + ("xirgi qiymat `" + printValue(value, true) + "` ga teng.");

    if (value === null) {
      msg += "\n Agar \"null\" bo\u2018sh qiymat bo\u2018lsa, sxemada `.nullable()` qilib belgilanganligiga ishonch hosil qiling";
    }

    return msg;
  }
};
var string$h = {
  length: '${path} maydoni ${length}ta belgidan iborat emas',
  min: '${path} maydoni kamida ${min}ta belgidan iborat bo‘lishi lozim',
  max: '${path} maydoni ko‘pi bilan ${max}ta belgidan iborat bo‘lishi mumkin',
  matches: '${path} maydon qiymati "${regex}" muntazam ifodaga mos emas',
  email: '${path} maydon qiymati e-mail emas',
  url: '${path} maydon qiymati havola emas',
  trim: '${path} mayqon qiymati boshida yoki oxirida bo‘shliqlar mavjud',
  lowercase: '${path} mayqon qiymat kichik harflardan iborat emas',
  uppercase: '${path} mayqon qiymat bosh (katta) harflardan iborat emas'
};
var number$h = {
  min: '${path} maydon qiymati ${min}dan kichik',
  max: '${path} maydon qiymati ${max}dan katta',
  lessThan: '${path} maydon qiymati ${less}dan kichik emas',
  moreThan: '${path} maydon qiymati ${more}dan katta emas',
  positive: '${path} maydon qiymati musbat son emas',
  negative: '${path} maydon qiymati manfiy son emas',
  integer: '${path} maydon qiymati butun son emas'
};
var date$h = {
  min: '${path} maydon qiymati ${min} sanandan oldin bo‘lmasligi lozim',
  max: '${path} maydon qiymati ${max} sanadan keyin bo‘lmasligi lozim'
};
var _boolean$h = {
  isValue: '${path} maydon qiymati ${value} bo‘lishi shart'
};
var object$h = {
  noUnknown: '${path} maydon qiymatida noma\'lum kalitlar mavjud'
};
var array$h = {
  min: '${path} maydon kamida ${min}ta elementdan iborat bo‘lishi lozim',
  max: '${path} maydon ko‘pi bilan ${max} elementdan iborat bo‘lishi mumkin'
};

var uz = {
  __proto__: null,
  mixed: mixed$h,
  string: string$h,
  number: number$h,
  date: date$h,
  boolean: _boolean$h,
  object: object$h,
  array: array$h
};

export { ar, cs, da, de, es, fr, he, id, it, lt, nb, nl, pl, pt, ru, sk, tr, uz };
//# sourceMappingURL=yup-locales.esm.js.map
